import { watchBusy } from "@frui.ts/screens";
import { attachAutomaticValidator, validate } from "@frui.ts/validation";
import { bound } from "@frui.ts/helpers";
import { Modules } from "config";
import { endOfDay, isSameDay, startOfDay } from "date-fns";
import {
  BlacklistedEmailAddressCreateRequest,
  BlacklistedEmailAddressCreateValidationRules,
} from "entities/blacklistedEmailAddressRequest";
import type EmailBlacklistRepository from "repositories/emailBlacklistRepository";
import type EventBus from "services/eventBus";
import type LocalizationService from "services/localizationService";
import type NotificationService from "services/notificationService";
import type SecurityService from "services/securityService";
import CreateViewModel from "../../createViewModel";

export default class EmailBlacklistCreateViewModel extends CreateViewModel<BlacklistedEmailAddressCreateRequest> {
  readonly modelName = "emailBlacklist";

  constructor(
    protected repository: EmailBlacklistRepository,
    protected localizationService: LocalizationService,
    protected securityService: SecurityService,
    protected eventBus: EventBus,
    protected notificationService: NotificationService
  ) {
    super();
  }

  protected loadDetail(): BlacklistedEmailAddressCreateRequest {
    const item = new BlacklistedEmailAddressCreateRequest();
    item.validSinceDate = new Date();
    attachAutomaticValidator(item, BlacklistedEmailAddressCreateValidationRules);
    return item;
  }

  @bound
  @watchBusy
  async create() {
    if (!validate(this.item)) {
      return;
    }

    if (this.item.validSinceDate) {
      if (isSameDay(this.item.validSinceDate, new Date())) {
        this.item.validSinceDate = new Date();
      } else {
        this.item.validSinceDate = startOfDay(this.item.validSinceDate);
      }
    }
    if (this.item.validUntilDate) {
      this.item.validUntilDate = endOfDay(this.item.validUntilDate);
    }

    await super.create();
  }

  translate(code: string, size?: number): string {
    return this.localizationService.translateModule(Modules.administration, `emailBlacklists.${code}`, size);
  }

  translateSubAttribute(model: string, attribute: string): string {
    return this.localizationService.translateAttribute(model, attribute);
  }
}
